import React from "react";


const PendingInventoryForm = ({
  inventory,
  item,
  errors,
  onValueChange,
  onSubmit,
}) => {
  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-block">
          <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
              noValidate
            >
              <div className={errors.indexOf("weight") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-10 col-form-label" htmlFor="text-input">
                  Qty
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="number"
                    id="text-input"
                    name="text-input"
                    className={errors.indexOf("weight") !== -1 ? "form-control form-control-danger" : "form-control"}
                    placeholder="Enter quantity"
                    value={inventory.weight}
                    onChange={(event) => onValueChange('weight', event.target.value)}
                    autoFocus
                  />
                </div>
                <div className="col-sm-2 col-2 pl-0">
                  <h4><span className="badge badge-pill badge-info font-sm">{item.measure_unit ? item.measure_unit : 'kg'}</span></h4>
                </div>
                {errors.indexOf("weight") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter a positive value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>

              <div className={errors.indexOf("number_items") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                  Pieces
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="number"
                    id="text-input"
                    name="text-input"
                    className={errors.indexOf("pieces") !== -1 ? "form-control form-control-danger" : "form-control"}
                    placeholder="Enter pieces"
                    value={inventory.number_items}
                    onChange={(event) => onValueChange('number_items', event.target.value)}
                  />
                </div>
                {errors.indexOf("number_items") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter a positive value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>

              <div className={errors.indexOf("plant") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                  Plant
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    className={errors.indexOf("plant") !== -1 ? "form-control form-control-danger" : "form-control"}
                    placeholder="Enter plant"
                    value={inventory.plant}
                    onChange={(event) => onValueChange('plant', event.target.value)}
                  />
                </div>
                {errors.indexOf("plant") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter a value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>

              <div className={errors.indexOf("temperature") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                  Temperature
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="number"
                    id="text-input"
                    name="text-input"
                    className={errors.indexOf("temperature") !== -1 ? "form-control form-control-danger" : "form-control"}
                    placeholder="Enter temperature"
                    value={inventory.temperature}
                    onChange={(event) => onValueChange('temperature', event.target.value)}
                  />
                </div>
                <div className="col-sm-2 col-2 pl-0">
                  <h4><span className="badge badge-pill badge-info font-sm">°F</span></h4>
                </div>
                {errors.indexOf("temperature") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>

              <div className={errors.indexOf("box_condition") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                  Box Condition
                </label>
                <div className="col-sm-6 col-10">
                  <div className="d-flex align-items-center justify-content-start">
                    <input
                      type="radio"
                      id="box-condition-good"
                      name="box-condition"
                      value="good"
                      checked={inventory.box_condition}
                      onChange={() => onValueChange('box_condition', 'good')}
                    />
                    <label className="m-0 ml-05" htmlFor="box-condition-good">Good</label>
                  </div>
                  <div className="d-flex align-items-center justify-content-start">
                    <input
                      type="radio"
                      id="box-condition-bad"
                      name="box-condition"
                      value="bad"
                      onChange={() => onValueChange('box_condition', 'bad')}
                    />
                    <label className="m-0 ml-05" htmlFor="box-condition-bad">Bad</label>
                  </div>
                </div>
                {errors.indexOf("box_condition") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>

              <div className={errors.indexOf("packing_date") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-10 col-form-label" htmlFor="date-input">
                  Packing Date
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="date"
                    id="date-input"
                    name="date-input"
                    className={errors.indexOf("packing_date") !== -1 ? "form-control form-control-danger" : "form-control"}
                    value={inventory.packing_date}
                    onChange={(event) => onValueChange("packing_date", event.target.value)}
                  />
                </div>
                {errors.indexOf("packing_date") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    The packing date should be either today or in the past.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>
              <div className={errors.indexOf("vendor_lot_number") !== -1 ? "col-sm-6 form-group row has-danger" : "col-sm-6 form-group row"}>
                <label className="col-sm-4 col-12 col-form-label" htmlFor="text-input">
                  Lot
                </label>
                <div className="col-sm-6 col-10">
                  <input
                    type="text"
                    id="lot-input"
                    name="lot-input"
                    className={errors.indexOf("vendor_lot_number") !== -1 ? "form-control form-control-danger" : "form-control"}
                    placeholder="Enter lot"
                    value={inventory.vendor_lot_number}
                    onChange={(event) => onValueChange('vendor_lot_number', event.target.value)}
                  />
                </div>
                {errors.indexOf("vendor_lot_number") !== -1 ? (
                  <em id="firstname-error" className="error form-control-feedback">
                    Please enter a value.
                  </em>
                ) : (
                  <em></em>
                )}
              </div>
              <button type="submit" hidden />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingInventoryForm;
